enum ImageStatus {
    success,
    loading,
    fail,
    none
}

export default ImageStatus;
